import {
  MANAGE_CHATBOT, CHATBOTIFY_BASIC_GENERAL_DATA, PREV_CHATBOTIFY_DATA, SET_NO_SERVICE_DETAILS,
  CHAT_SENSITIVE_DATA
} from '../../common/actionTypes';
const INITIAL_STATE = {
  manage_chatbot: {},
  chatbotifyGeneralBasicData: {},
  prevChatbotifyData: {},
  noServiceDetails: {},
  serviceDetails: false,
  chatSensitiveData: {}
};

const chatbotReducer = (state = INITIAL_STATE, action) => {
  if (action.type === undefined) {
    return state;
  }
  switch (action.type) {
    case MANAGE_CHATBOT: {
      return { ...state, manage_chatbot: action.payload };
    }
    case CHATBOTIFY_BASIC_GENERAL_DATA: {
      return { ...state, chatbotifyGeneralBasicData: action.payload };
    }
    case PREV_CHATBOTIFY_DATA: {
      return { ...state, prevChatbotifyData: action.payload };
    }
    case SET_NO_SERVICE_DETAILS: {
      return { ...state, noServiceDetails: action.payload };
    }
    case CHAT_SENSITIVE_DATA: {
      return { ...state, chatSensitiveData: action.payload };
    }
    default:
      return state;
  }
};

export default chatbotReducer;
